export const hasFreshTrendsV2Capability = ({ features, fresh = false } = {}) => (
  fresh === true
  && features?.trendsV2 === true
  && Array.isArray(features?.trendsSchemaVersions)
  && features.trendsSchemaVersions.includes(2)
);
